import {formatPercent} from '@angular/common';
import {Pipe, PipeTransform, inject} from '@angular/core';
import {LocaleService} from '../../translation/services/locale.service';

@Pipe({
  name: 'localizedPercent',
  pure: false
})
export class LocalizedPercentPipe implements PipeTransform {
  private readonly localeService = inject(LocaleService);

  transform(
    value: string | number | null | undefined,
    digitsInfo?: string,
  ): string | null {
    if (value === null || value === undefined) {
      return null;
    }

    return formatPercent(Number(value), this.localeService.userLanguage, digitsInfo);
  }
}
